// extracted by mini-css-extract-plugin
module.exports = {"errorBag":"errorbag_errorBag__V9pVk","mb":"errorbag_mb__r8tcu"};